export const releaseNotesVersion = [
  {
    id: 2,
    version: "v1.8.4",
    releaseDate: "12/16/2024",
  },
];
